module.exports = __webpack_public_path__ + "static/media/VectorMinus.2f80f8b1.svg";